import apiService from '@/services/apiService';

const actions = {
  postContactUs({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('setting/contact-us', payload)
        .then((response) => {
          commit('postContactUs', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getContactUs({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('setting/contact-us')
        .then((response) => {
          resolve(response.data.data);
          commit('getContactUs', response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getContactUsId({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`setting/contact-us/${payload}`)
        .then((response) => {
          resolve(response.data.data);
          commit('getContactUsId', response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  updateContactUs({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('setting/contact-us/update-status', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putContactUs({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`setting/contact-us/${payload.id}`, payload.formData)
        .then((response) => {
          commit('putContactUs', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delContactUs({ commit }, payload) {
    apiService.delete(`setting/contact-us/${payload}`)
      .then((response) => {
        commit('delContactUs', payload);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  postEnableDisableFeature({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('setting/enabled-disabled-feature', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getEnableDisableFeature({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('setting/enabled-disabled-feature/find-with-paging', payload)
        .then((response) => {
          resolve(response);
          commit('getEnableDisableFeature', response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getEnableDisableFeatureId({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`setting/enabled-disabled-feature/${payload}`)
        .then((response) => {
          resolve(response.data.data);
          commit('getEnableDisableFeatureId', response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  updateEnableDisableFeature({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('setting/enabled-disabled-feature/update-status', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putEnableDisableFeature({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`setting/enabled-disabled-feature/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delEnableDisableFeature({ commit }, payload) {
    apiService.delete(`setting/enabled-disabled-feature/${payload}`)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  postNewUser({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('setting/new-user', payload)
        .then((response) => {
          commit('postNewUser', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getNewUser({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('setting/new-user')
        .then((response) => {
          resolve(response.data.data);
          commit('getNewUser', response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getNewUserId({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`setting/new-user/${payload}`)
        .then((response) => {
          resolve(response.data.data);
          commit('getNewUserId', response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  updateNewUser({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('setting/new-user/update-status', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putNewUser({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`setting/new-user/${payload.id}`, payload.formData)
        .then((response) => {
          commit('putNewUser', payload);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delNewUser({ commit }, payload) {
    apiService.delete(`setting/new-user/${payload}`)
      .then((response) => {
        commit('delNewUser', payload);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },


};

export default actions;
